var siteBackground = document.getElementById("site-background");
var pageWidth = siteBackground.offsetWidth;

// site-background's height is always 100vh so we need to get creative to find the real height
// halved because it's scaled by 2 to account for perspective
var pageHeight = (document.getElementById("site-main").offsetHeight + document.getElementById("title-splash").offsetHeight) * 0.5;



document.addEventListener("DOMContentLoaded", (event) => {

    // if the page has a video background in the post contents, use that
    var videoBackground = document. querySelector("figure.kg-video-card.kg-width-full");
    if(videoBackground) {
        //    move that background outside of the parallax area
        //    turn off perspective

        var siteContainer = document.getElementById("site-container");
        siteContainer.style = "perspective:none;";
        videoBackground.remove();
        videoBackground.classList.add("video-background");
        siteContainer.appendChild(videoBackground);
    }  
    else {
        createSmallElements(pageHeight/200);
        createLargeElements(pageHeight/1000);
    }
});


function createLargeElements(count) {
    for(i=0; i<count; i++) {
        var newElement = createFloatingPicture("/content/themes/tranglam/assets/images/home-bg/large", Math.floor(Math.random()*4), "back") //4 = number of items in /large
        var randomWidth = Math.random() * 500 + 900;
        var offsetX = Math.floor(Math.random() * (pageWidth - randomWidth));
        var offsetY = Math.floor(Math.random() * (pageHeight - 900));
        
        newElement.style = `width: ${randomWidth}px; left: ${offsetX}px; top: ${offsetY}px;`;


        siteBackground.appendChild(newElement);
    }
}
function createSmallElements(count) {
    for(i=0; i<count; i++) {
        var newElement = createFloatingPicture("/content/themes/tranglam/assets/images/home-bg/small", Math.floor(Math.random()*14)) //14 = number of items in /small
        var randomWidth = Math.random() * 400 + 150;
        var offsetX = Math.floor(Math.random() * (pageWidth - randomWidth));
        var offsetY = Math.floor(Math.random() * (pageHeight - 400));
        
        newElement.style = `width: ${randomWidth}px; left: ${offsetX}px; top: ${offsetY}px;`;
        siteBackground.appendChild(newElement);
    }
}

function createFloatingPicture(imagePath, imageIndex, pClass = "front") {
    var srcPath = `${imagePath}/${imageIndex}.webp`;

    var newPic = document.createElement("img");
    newPic.src = srcPath;
    newPic.classList.add(pClass);
    return newPic;
}